export default __webpack_public_path__ + "static/car-navy-f428913d94c2b95260448180aff9f25c.svg";